var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"rightAD",staticClass:"right-AD"},[(_vm.imgUrl)?_c('div',[_c('img',{attrs:{"src":_vm.baseURL+_vm.imgUrl,"alt":""},on:{"click":_vm.jump}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }